import { Box, Flex, Text } from '@chakra-ui/react'
import { useLocale, type Locale } from '@/i18n'

const LOCALES: readonly Locale[] = ['en', 'hu']

const LocaleButton = ({ target }: { target: Locale }) => {
  const { locale, setLocale } = useLocale()
  const isActive = locale === target
  return (
    <Box
      as="button"
      aria-pressed={isActive}
      aria-label={target === 'en' ? 'Switch to English' : 'Váltás magyarra'}
      onClick={() => {
        setLocale(target)
      }}
      fontSize="13px"
      letterSpacing="0.1em"
      color={isActive ? 'ink' : 'neutral.500'}
      cursor="pointer"
      transition="color 0.2s"
      _hover={{ color: 'ink' }}
    >
      {target.toUpperCase()}
    </Box>
  )
}

export const LanguageToggle = () => (
  <Flex gap={2} align="center">
    {LOCALES.map((target, index) => (
      <Flex key={target} gap={2} align="center">
        {index > 0 && (
          <Text fontSize="13px" color="neutral.500">
            /
          </Text>
        )}
        <LocaleButton target={target} />
      </Flex>
    ))}
  </Flex>
)
